// import React, { useState, useEffect, useCallback } from "react";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Doughnut, Pie, Line, Bar } from "react-chartjs-2";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import Header from "../../Common/Layout/Header";
// import MarketingTabs from "../AllTabs/MarketingTabs";
// import { useNavigate } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { RiCalendarLine } from "react-icons/ri";
// import moment from "moment";

// // Register ChartJS components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const LeadManagementDashboard = () => {
//   const navigate = useNavigate();
//   const { user, loading } = useAuth();
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [sourceFilter, setSourceFilter] = useState("all");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [dashboardData, setDashboardData] = useState({
//     sourceCounts: [],
//     monthlyTrend: [],
//     conversionBySource: [],
//     leadStatusCounts: [],
//     totalLeads: 0,
//     dateRange: {
//       fromDate: "",
//       toDate: "",
//     },
//   });
//   const [leadStatuses, setLeadStatuses] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   // Custom input component for date picker
//   const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
//     <div className="input-group">
//       <input
//         type="text"
//         className="form-control"
//         value={value}
//         onClick={onClick}
//         ref={ref}
//         readOnly
//         placeholder="Select date"
//       />
//       <button className="btn btn-secondary" type="button" onClick={onClick}>
//         <RiCalendarLine />
//       </button>
//     </div>
//   ));

//   const formatDate = (date) => {
//     return moment(date).format("YYYY-MM-DD");
//   };

//   // Set default dates to current month on component mount
//   useEffect(() => {
//     const today = new Date();
//     const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
//     const lastDayOfMonth = new Date(
//       today.getFullYear(),
//       today.getMonth() + 1,
//       0
//     );

//     setFromDate(firstDayOfMonth);
//     setToDate(lastDayOfMonth);
//   }, []);

//   // Fetch lead statuses
//   const GetLeadStatus = useCallback(async () => {
//     if (!user?.cid) return;

//     try {
//       const res = await apiService.getAll(
//         `${config.GETLEADSTATUSBYCOMPANY}/${user?.cid}`
//       );
//       setLeadStatuses(res.data || []);
//     } catch (error) {
//       console.error("Error fetching lead statuses:", error);
//       setLeadStatuses([]);
//     }
//   }, [user]);

//   // Fetch data when component loads or filters change
//   useEffect(() => {
//     if (user?.cid) {
//       GetLeadStatus();
//     }
//   }, [user, GetLeadStatus]);

//   // Fetch data when component loads or filters change
//   useEffect(() => {
//     if (fromDate && toDate && user?.id) { // Changed from user?.cid to user?.id
//       GetData();
//     }
//   }, [fromDate, toDate, sourceFilter, statusFilter, user]);

//   // Fetch data from backend - UPDATED to use user-based API
//   const GetData = useCallback(async () => {
//     if (!user?.id) return; // Changed from user?.cid to user?.id

//     setIsLoading(true);
//     try {
//       // Build query parameters
//       const params = new URLSearchParams();

//       // Convert Date objects to string format for API
//       const fromDateStr =
//         fromDate instanceof Date ? formatDate(fromDate) : fromDate;
//       const toDateStr = toDate instanceof Date ? formatDate(toDate) : toDate;

//       if (fromDateStr) params.append("fromDate", fromDateStr);
//       if (toDateStr) params.append("toDate", toDateStr);
//       if (sourceFilter !== "all") params.append("sourceName", sourceFilter);
//       if (statusFilter !== "all") params.append("leadStatus", statusFilter); // Changed from leadStatusId to leadStatus

//       // Use the new user-based API endpoint - CHANGED HERE
//       const url = `${config.GETLEADDASHBOARDBYUSER}/${user.id}?${params}`;
//       const response = await apiService.getAll(url);

//       // Set dashboard data with proper fallbacks
//       setDashboardData({
//         sourceCounts: response?.sourceCounts || [],
//         monthlyTrend: response?.monthlyTrend || [],
//         conversionBySource: response?.conversionBySource || [],
//         leadStatusCounts: response?.leadStatusCounts || [],
//         totalLeads: response?.totalLeads || 0,
//         dateRange: response?.dateRange || {
//           fromDate: fromDateStr,
//           toDate: toDateStr,
//         },
//       });
//     } catch (error) {
//       console.error("Error fetching lead dashboard data:", error);
//       setDashboardData({
//         sourceCounts: [],
//         monthlyTrend: [],
//         conversionBySource: [],
//         leadStatusCounts: [],
//         totalLeads: 0,
//         dateRange: {
//           fromDate: "",
//           toDate: "",
//         },
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   }, [user, fromDate, toDate, sourceFilter, statusFilter]);

//   // Reset filters
//   const resetFilters = () => {
//     const today = new Date();
//     const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
//     const lastDayOfMonth = new Date(
//       today.getFullYear(),
//       today.getMonth() + 1,
//       0
//     );

//     setFromDate(firstDayOfMonth);
//     setToDate(lastDayOfMonth);
//     setSourceFilter("all");
//     setStatusFilter("all");
//   };

//   // Handle date changes for DatePicker
//   const handleFromDateChange = (date) => {
//     setFromDate(date);
//   };

//   const handleToDateChange = (date) => {
//     setToDate(date);
//   };

//   const statusColors = {
//     NEW: {
//       background: "linear-gradient(135deg, #4361ee, #3a56d4)",
//       chart: "#4361ee",
//       icon: "#ffffff",
//     },
//     PROCESSING: {
//       background: "linear-gradient(135deg, #9c27b0, #7b1fa2)",
//       chart: "#9c27b0",
//       icon: "#ffffff",
//     },
//     "NOT RESPONDING": {
//       background: "linear-gradient(135deg, #ef476f, #e03c5f)",
//       chart: "#ef476f",
//       icon: "#ffffff",
//     },
//     "FOLLOW UP": {
//       background: "linear-gradient(135deg, #f9c74f, #f4b400)",
//       chart: "#f9c74f",
//       icon: "#ffffff",
//     },
//     CLOSED: {
//       background: "linear-gradient(135deg, #dc2626, #b91c1c)",
//       chart: "#dc2626",
//       icon: "#ffffff",
//     },
//     REPLIED: {
//       background: "linear-gradient(135deg, #10b981, #0da271)",
//       chart: "#10b981",
//       icon: "#ffffff",
//     },
//     "NOT WORKING": {
//       background: "linear-gradient(135deg, #6c757d, #5a6268)",
//       chart: "#6c757d",
//       icon: "#ffffff",
//     },
//   };

//   // Common source colors array for both charts
//   const sourceColors = [
//     "#1E40AF",
//     "#7E22CE",
//     "#DC2626",
//     "#059669",
//     "#D97706",
//     "#7C3AED",
//     "#EA580C",
//     "#0D9488",
//     "#BE185D",
//     "#4338CA",
//     "#B45309",
//     "#047857",
//     "#6D28D9",
//     "#C2410C",
//     "#0F766E",
//     "#A21CAF",
//     "#1D4ED8",
//     "#B45309",
//     "#15803D",
//     "#7C2D12",
//   ];

//   // Function to get color for a specific source name (consistent across both charts)
//   const getSourceColor = (sourceName, index) => {
//     // Create a mapping of source names to colors for consistency
//     const sourceColorMap = {};

//     if (dashboardData.sourceCounts && dashboardData.conversionBySource) {
//       // Get all unique source names from both datasets
//       const allSources = [
//         ...dashboardData.sourceCounts.map((item) => item.sourceName),
//         ...dashboardData.conversionBySource.map((item) => item.sourceName),
//       ];

//       const uniqueSources = [...new Set(allSources)];

//       // Assign colors to each unique source
//       uniqueSources.forEach((source, idx) => {
//         sourceColorMap[source] = sourceColors[idx % sourceColors.length];
//       });
//     }

//     // Return color for the specific source, or fallback to index-based color
//     return (
//       sourceColorMap[sourceName] || sourceColors[index % sourceColors.length]
//     );
//   };
  
//   // Updated source chart data (Leads by Source) - removed borders
//   const sourceChartData = {
//     labels:
//       dashboardData.sourceCounts?.map(
//         (item) => `${item.sourceName} (${item.count})`
//       ) || [],
//     datasets: [
//       {
//         data: dashboardData.sourceCounts?.map((item) => item.count) || [],
//         backgroundColor:
//           dashboardData.sourceCounts?.map((item, index) =>
//             getSourceColor(item.sourceName, index)
//           ) || [],
//         borderColor: "transparent", // Remove black border
//         borderWidth: 0, // Remove border
//         hoverBorderWidth: 0, // Remove hover border
//         hoverOffset: 15,
//         spacing: 2,
//         borderRadius: 8,
//       },
//     ],
//   };

//   // Monthly Trend Chart Data
//   const trendChartData = {
//     labels: dashboardData.monthlyTrend?.map((item) => item.displayDate) || [],
//     datasets: [
//       {
//         label: "Leads",
//         data: dashboardData.monthlyTrend?.map((item) => item.leadCount) || [],
//         borderColor: "#4361ee",
//         backgroundColor: "rgba(67, 97, 238, 0.1)",
//         tension: 0.4,
//         fill: true,
//         pointBackgroundColor: "#4361ee",
//         pointBorderColor: "#fff",
//         pointBorderWidth: 2,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//       },
//     ],
//   };

//   // Updated conversion chart data (Conversion by Source) - removed borders
//   const conversionChartData = {
//     labels:
//       dashboardData.conversionBySource?.map((item) => item.sourceName) || [],
//     datasets: [
//       {
//         label: "Conversion Rate %",
//         data:
//           dashboardData.conversionBySource?.map(
//             (item) => item.conversionRate
//           ) || [],
//         backgroundColor:
//           dashboardData.conversionBySource?.map((item, index) =>
//             getSourceColor(item.sourceName, index)
//           ) || [],
//         borderColor: "transparent", // Remove black border
//         borderWidth: 0, // Remove border
//         borderRadius: 8,
//         borderSkipped: false,
//       },
//     ],
//   };

//   // Source chart options (Leads by Source - Doughnut) - dark text
//   const sourceChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "right",
//         labels: {
//           usePointStyle: true,
//           pointStyle: "circle",
//           padding: 20,
//           font: {
//             size: 12,
//             family: "'Inter', sans-serif",
//             weight: "500",
//           },
//           color: "#1F2937", // Dark text color
//         },
//       },
//       tooltip: {
//         backgroundColor: "rgba(17, 24, 39, 0.95)",
//         titleColor: "#F9FAFB",
//         bodyColor: "#D1D5DB",
//         borderColor: "#374151",
//         borderWidth: 1,
//         cornerRadius: 8,
//         boxPadding: 10,
//         usePointStyle: true,
//         callbacks: {
//           label: function (context) {
//             const label = context.label.replace(/\(\d+\)/, "").trim();
//             const value = context.raw || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = Math.round((value / total) * 100);
//             return `${label}: ${value} leads (${percentage}%)`;
//           },
//           labelColor: function (context) {
//             return {
//               backgroundColor:
//                 context.dataset.backgroundColor[context.dataIndex],
//               borderColor: "transparent", // Remove border
//               borderWidth: 0,
//               borderRadius: 2,
//             };
//           },
//         },
//       },
//       title: {
//         display: true,
//         text: "Leads by Source",
//         color: "#1F2937", // Dark text color
//         font: {
//           size: 16,
//           weight: "bold",
//         },
//       },
//     },
//     cutout: "55%",
//     animation: {
//       animateScale: true,
//       animateRotate: true,
//       duration: 1000,
//       easing: "easeOutQuart",
//     },
//     elements: {
//       arc: {
//         borderWidth: 0, // Remove border
//         borderColor: "transparent",
//       },
//     },
//   };

//   const trendChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         mode: "index",
//         intersect: false,
//         backgroundColor: "rgba(0, 0, 0, 0.8)",
//         titleColor: "#fff",
//         bodyColor: "#fff",
//         borderColor: "#4361ee",
//         borderWidth: 1,
//         callbacks: {
//           label: function (context) {
//             return `Leads: ${context.raw}`;
//           },
//         },
//       },
//     },
//     scales: {
//       x: {
//         grid: {
//           display: false,
//         },
//         ticks: {
//           maxRotation: 45,
//           minRotation: 45,
//         },
//       },
//       y: {
//         beginAtZero: true,
//         grid: {
//           color: "rgba(0, 0, 0, 0.1)",
//         },
//         ticks: {
//           stepSize: 1,
//         },
//       },
//     },
//     interaction: {
//       mode: "nearest",
//       axis: "x",
//       intersect: false,
//     },
//   };

//   // Conversion chart options (Conversion by Source - Bar) - dark text
//   const conversionChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         backgroundColor: "rgba(17, 24, 39, 0.95)",
//         titleColor: "#F9FAFB",
//         bodyColor: "#D1D5DB",
//         borderColor: "#374151",
//         borderWidth: 1,
//         cornerRadius: 8,
//         callbacks: {
//           label: function (context) {
//             const sourceData =
//               dashboardData.conversionBySource?.[context.dataIndex];
//             if (sourceData) {
//               return [
//                 `Source: ${sourceData.sourceName}`,
//                 `Conversion Rate: ${sourceData.conversionRate}%`,
//                 `Total Leads: ${sourceData.totalLeads}`,
//                 `Converted: ${sourceData.convertedLeads}`,
//               ];
//             }
//             return `Conversion Rate: ${context.raw}%`;
//           },
//           labelColor: function (context) {
//             return {
//               backgroundColor:
//                 context.dataset.backgroundColor[context.dataIndex],
//               borderColor: "transparent", // Remove border
//               borderWidth: 0,
//               borderRadius: 2,
//             };
//           },
//         },
//       },
//       title: {
//         display: true,
//         text: "Conversion by Source",
//         color: "#1F2937", // Dark text color
//         font: {
//           size: 16,
//           weight: "bold",
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         max: 100,
//         ticks: {
//           callback: function (value) {
//             return value + "%";
//           },
//           color: "#1F2937", // Dark text color
//         },
//         grid: {
//           color: "rgba(0, 0, 0, 0.1)",
//         },
//         title: {
//           display: true,
//           text: "Conversion Rate %",
//           color: "#1F2937", // Dark text color
//         },
//       },
//       x: {
//         ticks: {
//           color: "#1F2937", // Dark text color
//         },
//         grid: {
//           color: "rgba(0, 0, 0, 0.1)",
//         },
//         title: {
//           display: true,
//           text: "Sources",
//           color: "#1F2937", // Dark text color
//         },
//       },
//     },
//   };

//   // Calculate total converted leads
//   const totalConvertedLeads =
//     dashboardData.conversionBySource?.reduce(
//       (total, source) => total + source.convertedLeads,
//       0
//     ) || 0;

//   // SVG Icons
//   const PlusCircleIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <circle cx="12" cy="12" r="10"></circle>
//       <line x1="12" y1="8" x2="12" y2="16"></line>
//       <line x1="8" y1="12" x2="16" y2="12"></line>
//     </svg>
//   );

//   const ProcessingIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M21 12a9 9 0 1 1-9-9"></path>
//       <path d="M21 3v6h-6"></path>
//       <path d="M21 3l-9 9"></path>
//     </svg>
//   );

//   const CheckCircleIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
//       <polyline points="22 4 12 14.01 9 11.01"></polyline>
//     </svg>
//   );

//   const TimesCircleIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <circle cx="12" cy="12" r="10"></circle>
//       <line x1="15" y1="9" x2="9" y2="15"></line>
//       <line x1="9" y1="9" x2="15" y2="15"></line>
//     </svg>
//   );

//   const SyncIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M23 4v6h-6"></path>
//       <path d="M1 20v-6h6"></path>
//       <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path>
//       <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path>
//     </svg>
//   );

//   const LockIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//       <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//     </svg>
//   );

//   const BanIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <circle cx="12" cy="12" r="10"></circle>
//       <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
//     </svg>
//   );

//   if (loading) return <p>Loading...</p>;
//   if (!user) {
//     navigate("/");
//     return null;
//   }

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="col-xl-12">
//               <div className="card">
//                 <div className="p-2">
//                   <MarketingTabs pageName="LEADDASHBOARD" />
//                 </div>
//                 <div className="card-body">
//                   {/* Filter Section */}
//                   <div className="row mb-4">
//                     <div className="col-12">
//                       <div className="card bg-light">
//                         <div className="card-body p-3">
//                           <div className="row g-3 align-items-end">
//                             {/* Date Range */}
//                             <div className="col-md-4">
//                               <div className="row g-2">
//                                 <div className="col-6">
//                                   <label className="form-label small">
//                                     From Date
//                                   </label>
//                                   <DatePicker
//                                     selected={fromDate}
//                                     onChange={handleFromDateChange}
//                                     customInput={<CustomDateInput />}
//                                     dateFormat="dd-MMM-yyyy"
//                                     showYearDropdown
//                                     showMonthDropdown
//                                     dropdownMode="select"
//                                   />
//                                 </div>
//                                 <div className="col-6">
//                                   <label className="form-label small">
//                                     To Date
//                                   </label>
//                                   <DatePicker
//                                     selected={toDate}
//                                     onChange={handleToDateChange}
//                                     customInput={<CustomDateInput />}
//                                     dateFormat="dd-MMM-yyyy"
//                                     showYearDropdown
//                                     showMonthDropdown
//                                     dropdownMode="select"
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                             {/* Source Filter */}
//                             <div className="col-md-2">
//                               <label
//                                 htmlFor="sourceFilter"
//                                 className="form-label fw-semibold"
//                               >
//                                 Source
//                               </label>
//                               <select
//                                 className="form-select form-select-sm"
//                                 id="sourceFilter"
//                                 value={sourceFilter}
//                                 onChange={(e) =>
//                                   setSourceFilter(e.target.value)
//                                 }
//                                 style={{ height: "38px" }}
//                               >
//                                 <option value="all">All Sources</option>
//                                 <option value="B2C">B2C</option>
//                                 <option value="WalkIn">Walk In</option>
//                                 <option value="ChatBot">ChatBot</option>
//                                 <option value="Phone Call">Phone Call</option>
//                                 <option value="General">General</option>
//                               </select>
//                             </div>

//                             {/* Status Filter */}
//                             <div className="col-md-2">
//                               <label
//                                 htmlFor="statusFilter"
//                                 className="form-label fw-semibold"
//                               >
//                                 Status
//                               </label>
//                               <select
//                                 className="form-select form-select-sm"
//                                 id="statusFilter"
//                                 value={statusFilter}
//                                 onChange={(e) =>
//                                   setStatusFilter(e.target.value)
//                                 }
//                                 style={{ height: "38px" }}
//                               >
//                                 <option value="all">All Statuses</option>
//                                 {leadStatuses.map((status) => (
//                                   <option
//                                     key={status.leadStatusId}
//                                     value={status.leadStatusName}
//                                   >
//                                     {status.leadStatusName}
//                                   </option>
//                                 ))}
//                               </select>
//                             </div>

//                             {/* Buttons */}
//                             <div className="col-md-2">
//                               <div className="d-flex gap-2 mt-4">
//                                 <button
//                                   className="btn btn-primary btn-sm w-100"
//                                   onClick={GetData}
//                                   style={{ height: "38px" }}
//                                   disabled={isLoading}
//                                 >
//                                   {isLoading ? "Loading..." : "Apply"}
//                                 </button>
//                                 <button
//                                   className="btn btn-danger btn-sm w-100"
//                                   onClick={resetFilters}
//                                   style={{ height: "38px" }}
//                                 >
//                                   Reset
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Stats Overview */}
//                   <div className="row mb-4">
//                     <div className="col-12">
//                       <div className="card bg-white">
//                         <div className="card-body bg-light">
//                           <div className="d-flex justify-content-between align-items-center mb-3">
//                             <h5 className="card-title mb-0 text-dark">
//                               Overview
//                             </h5>
//                             <div className="d-flex gap-3">
//                               <span className="badge bg-primary fs-6">
//                                 Total Leads: {dashboardData.totalLeads}
//                               </span>
//                               <span className="badge bg-success fs-6">
//                                 Converted: {totalConvertedLeads}
//                               </span>
//                             </div>
//                           </div>

//                           {/* Date Range Info */}
//                           {dashboardData.dateRange?.fromDate && (
//                             <div className="row mb-3">
//                               <div className="col-12">
//                                 <small className="text-muted">
//                                   Showing data from{" "}
//                                   {moment(
//                                     dashboardData.dateRange.fromDate
//                                   ).format("DD MMM YYYY")}{" "}
//                                   to{" "}
//                                   {moment(
//                                     dashboardData.dateRange.toDate
//                                   ).format("DD MMM YYYY")}
//                                 </small>
//                               </div>
//                             </div>
//                           )}

//                           {/* Status Cards - UPDATED with PROCESSING */}
//                           {isLoading ? (
//                             <div className="text-center py-4">
//                               Loading status data...
//                             </div>
//                           ) : (
//                             <div className="row">
//                               {[
//                                 "NEW",
//                                 "PROCESSING",
//                                 "FOLLOW UP",
//                                 "REPLIED",
//                                 "NOT RESPONDING",
//                                 "NOT WORKING",
//                                 "CLOSED",
//                               ].map((statusName, index) => {
//                                 // Find the status data from dashboard
//                                 const statusData =
//                                   dashboardData.leadStatusCounts?.find(
//                                     (item) => item.leadStatusName === statusName
//                                   );

//                                 const count = statusData ? statusData.count : 0;

//                                 const statusConfig =
//                                   statusColors[statusName] ||
//                                   statusColors["NEW"];
//                                 let icon;

//                                 switch (statusName) {
//                                   case "NEW":
//                                     icon = <PlusCircleIcon />;
//                                     break;
//                                   case "PROCESSING":
//                                     icon = <ProcessingIcon />;
//                                     break;
//                                   case "NOT RESPONDING":
//                                     icon = <TimesCircleIcon />;
//                                     break;
//                                   case "FOLLOW UP":
//                                     icon = <SyncIcon />;
//                                     break;
//                                   case "CLOSED":
//                                     icon = <LockIcon />;
//                                     break;
//                                   case "REPLIED":
//                                     icon = <CheckCircleIcon />;
//                                     break;
//                                   case "NOT WORKING":
//                                     icon = <BanIcon />;
//                                     break;
//                                   default:
//                                     icon = <PlusCircleIcon />;
//                                 }

//                                 return (
//                                   <div
//                                     key={index}
//                                     className="col-md-4 col-lg-2 mb-3"
//                                   >
//                                     <div
//                                       className="card text-white border-0 shadow-sm h-100"
//                                       style={{
//                                         background: statusConfig.background,
//                                         borderRadius: "15px",
//                                         overflow: "hidden",
//                                         transition:
//                                           "transform 0.3s ease, box-shadow 0.3s ease",
//                                       }}
//                                       onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform =
//                                           "translateY(-8px) scale(1.03)";
//                                         e.currentTarget.style.boxShadow =
//                                           "0 8px 20px rgba(0,0,0,0.3)";
//                                       }}
//                                       onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform =
//                                           "translateY(0) scale(1)";
//                                         e.currentTarget.style.boxShadow =
//                                           "0 4px 12px rgba(0,0,0,0.2)";
//                                       }}
//                                     >
//                                       <div className="card-body d-flex justify-content-between align-items-center p-3">
//                                         {/* Left Side */}
//                                         <div className="text-start">
//                                           <p className="mb-1 fw-semibold text-uppercase small text-white">
//                                             {statusName}
//                                           </p>
//                                           <h2
//                                             className="mb-0 fw-bold text-white"
//                                             style={{ fontSize: "2.5rem" }}
//                                           >
//                                             {count}
//                                           </h2>
//                                         </div>

//                                         {/* Right Side Icon */}
//                                         <div
//                                           className="status-icon fs-1"
//                                           style={{
//                                             opacity: 0.9,
//                                             transform: "scale(1)",
//                                             transition: "transform 0.4s ease",
//                                           }}
//                                         >
//                                           {icon}
//                                         </div>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 );
//                               })}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Charts */}
//                   <div className="row mb-4">
//                     {/* Leads by Source */}
//                     <div className="col-md-6 mb-3">
//                       <div
//                         className="card h-100 bg-white border-0 shadow-sm"
//                         style={{
//                           borderRadius: "15px",
//                           transition:
//                             "transform 0.3s ease, box-shadow 0.3s ease",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform =
//                             "translateY(-8px) scale(1.03)";
//                           e.currentTarget.style.boxShadow =
//                             "0 10px 25px rgba(0,0,0,0.25)";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform =
//                             "translateY(0) scale(1)";
//                           e.currentTarget.style.boxShadow =
//                             "0 4px 12px rgba(0,0,0,0.15)";
//                         }}
//                       >
//                         <div className="card-body bg-light">
//                           <h5 className="card-title text-dark">
//                             Leads by Source
//                           </h5>
//                           <div style={{ height: "300px" }}>
//                             {isLoading ? (
//                               <div className="d-flex justify-content-center align-items-center h-100">
//                                 Loading...
//                               </div>
//                             ) : dashboardData.sourceCounts?.length > 0 ? (
//                               <Doughnut
//                                 data={sourceChartData}
//                                 options={sourceChartOptions}
//                               />
//                             ) : (
//                               <div className="d-flex justify-content-center align-items-center h-100">
//                                 No data available
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Conversion by Source */}
//                     <div className="col-md-6 mb-3">
//                       <div
//                         className="card h-100 bg-white border-0 shadow-sm"
//                         style={{
//                           borderRadius: "15px",
//                           transition:
//                             "transform 0.3s ease, box-shadow 0.3s ease",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform =
//                             "translateY(-8px) scale(1.03)";
//                           e.currentTarget.style.boxShadow =
//                             "0 10px 25px rgba(0,0,0,0.25)";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform =
//                             "translateY(0) scale(1)";
//                           e.currentTarget.style.boxShadow =
//                             "0 4px 12px rgba(0,0,0,0.15)";
//                         }}
//                       >
//                         <div className="card-body bg-light">
//                           <h5 className="card-title text-dark">
//                             Conversion by Source
//                           </h5>
//                           <div style={{ height: "300px" }}>
//                             {isLoading ? (
//                               <div className="d-flex justify-content-center align-items-center h-100">
//                                 Loading...
//                               </div>
//                             ) : dashboardData.conversionBySource?.length > 0 ? (
//                               <Bar
//                                 data={conversionChartData}
//                                 options={conversionChartOptions}
//                               />
//                             ) : (
//                               <div className="d-flex justify-content-center align-items-center h-100">
//                                 No data available
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Leads Trend */}
//                   <div className="row">
//                     <div className="col-12 mb-3">
//                       <div
//                         className="card h-100 bg-white border-0 shadow-sm"
//                         style={{
//                           borderRadius: "15px",
//                           transition:
//                             "transform 0.3s ease, box-shadow 0.3s ease",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform =
//                             "translateY(-8px) scale(1.03)";
//                           e.currentTarget.style.boxShadow =
//                             "0 10px 25px rgba(0,0,0,0.25)";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform =
//                             "translateY(0) scale(1)";
//                           e.currentTarget.style.boxShadow =
//                             "0 4px 12px rgba(0,0,0,0.15)";
//                         }}
//                       >
//                         <div className="card-body bg-light">
//                           <h5 className="card-title text-dark">
//                             Leads Trend (
//                             {dashboardData.monthlyTrend?.length || 0} Days)
//                           </h5>
//                           <div style={{ height: "400px" }}>
//                             {isLoading ? (
//                               <div className="d-flex justify-content-center align-items-center h-100">
//                                 Loading...
//                               </div>
//                             ) : dashboardData.monthlyTrend?.length > 0 ? (
//                               <Line
//                                 data={trendChartData}
//                                 options={trendChartOptions}
//                               />
//                             ) : (
//                               <div className="d-flex justify-content-center align-items-center h-100">
//                                 No trend data available
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeadManagementDashboard;

import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut, Pie, Line, Bar } from "react-chartjs-2";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import Header from "../../Common/Layout/Header";
import MarketingTabs from "../AllTabs/MarketingTabs";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RiCalendarLine } from "react-icons/ri";
import moment from "moment";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const LeadManagementDashboard = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [sourceFilter, setSourceFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [dashboardData, setDashboardData] = useState({
    sourceCounts: [],
    monthlyTrend: [],
    conversionBySource: [],
    leadStatusCounts: [],
    totalLeads: 0,
    dateRange: {
      fromDate: "",
      toDate: "",
    },
  });
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Custom input component for date picker
  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        placeholder="Select date"
      />
      <button className="btn btn-secondary" type="button" onClick={onClick}>
        <RiCalendarLine />
      </button>
    </div>
  ));

  const formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  // Set default dates to current month on component mount
  useEffect(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );

    setFromDate(firstDayOfMonth);
    setToDate(lastDayOfMonth);
  }, []);

  // Fetch lead statuses
  const GetLeadStatus = useCallback(async () => {
    if (!user?.cid) return;

    try {
      const res = await apiService.getAll(
        `${config.GETLEADSTATUSBYCOMPANY}/${user?.cid}`
      );
      setLeadStatuses(res.data || []);
    } catch (error) {
      console.error("Error fetching lead statuses:", error);
      setLeadStatuses([]);
    }
  }, [user]);

  // Fetch data when component loads or filters change
  useEffect(() => {
    if (user?.cid) {
      GetLeadStatus();
    }
  }, [user, GetLeadStatus]);

  // Fetch data when component loads or filters change
  useEffect(() => {
    if (fromDate && toDate && user?.id) { // Changed from user?.cid to user?.id
      GetData();
    }
  }, [fromDate, toDate, sourceFilter, statusFilter, user]);

  // Fetch data from backend - UPDATED to use user-based API
  const GetData = useCallback(async () => {
    if (!user?.id) return; // Changed from user?.cid to user?.id

    setIsLoading(true);
    try {
      // Build query parameters
      const params = new URLSearchParams();

      // Convert Date objects to string format for API
      const fromDateStr =
        fromDate instanceof Date ? formatDate(fromDate) : fromDate;
      const toDateStr = toDate instanceof Date ? formatDate(toDate) : toDate;

      if (fromDateStr) params.append("fromDate", fromDateStr);
      if (toDateStr) params.append("toDate", toDateStr);
      if (sourceFilter !== "all") params.append("sourceName", sourceFilter);
      if (statusFilter !== "all") params.append("leadStatus", statusFilter); // Changed from leadStatusId to leadStatus

      // Use the new user-based API endpoint - CHANGED HERE
      const url = `${config.GETLEADDASHBOARDBYUSER}/${user.id}?${params}`;
      const response = await apiService.getAll(url);

      // Set dashboard data with proper fallbacks
      setDashboardData({
        sourceCounts: response?.sourceCounts || [],
        monthlyTrend: response?.monthlyTrend || [],
        conversionBySource: response?.conversionBySource || [],
        leadStatusCounts: response?.leadStatusCounts || [],
        totalLeads: response?.totalLeads || 0,
        dateRange: response?.dateRange || {
          fromDate: fromDateStr,
          toDate: toDateStr,
        },
      });
    } catch (error) {
      console.error("Error fetching lead dashboard data:", error);
      setDashboardData({
        sourceCounts: [],
        monthlyTrend: [],
        conversionBySource: [],
        leadStatusCounts: [],
        totalLeads: 0,
        dateRange: {
          fromDate: "",
          toDate: "",
        },
      });
    } finally {
      setIsLoading(false);
    }
  }, [user, fromDate, toDate, sourceFilter, statusFilter]);

  // Reset filters
  const resetFilters = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );

    setFromDate(firstDayOfMonth);
    setToDate(lastDayOfMonth);
    setSourceFilter("all");
    setStatusFilter("all");
  };

  // Handle date changes for DatePicker
  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const statusColors = {
    NEW: {
      background: "linear-gradient(135deg, #4361ee, #3a56d4)",
      chart: "#4361ee",
      icon: "#ffffff",
    },
    PROCESSING: {
      background: "linear-gradient(135deg, #9c27b0, #7b1fa2)",
      chart: "#9c27b0",
      icon: "#ffffff",
    },
    "NOT RESPONDING": {
      background: "linear-gradient(135deg, #ef476f, #e03c5f)",
      chart: "#ef476f",
      icon: "#ffffff",
    },
    "FOLLOW UP": {
      background: "linear-gradient(135deg, #f9c74f, #f4b400)",
      chart: "#f9c74f",
      icon: "#ffffff",
    },
    CLOSED: {
      background: "linear-gradient(135deg, #dc2626, #b91c1c)",
      chart: "#dc2626",
      icon: "#ffffff",
    },
    REPLIED: {
      background: "linear-gradient(135deg, #10b981, #0da271)",
      chart: "#10b981",
      icon: "#ffffff",
    },
    "NOT WORKING": {
      background: "linear-gradient(135deg, #6c757d, #5a6268)",
      chart: "#6c757d",
      icon: "#ffffff",
    },
  };

  // Common source colors array for both charts
  const sourceColors = [
    "#1E40AF",
    "#7E22CE",
    "#DC2626",
    "#059669",
    "#D97706",
    "#7C3AED",
    "#EA580C",
    "#0D9488",
    "#BE185D",
    "#4338CA",
    "#B45309",
    "#047857",
    "#6D28D9",
    "#C2410C",
    "#0F766E",
    "#A21CAF",
    "#1D4ED8",
    "#B45309",
    "#15803D",
    "#7C2D12",
  ];

  // Function to get color for a specific source name (consistent across both charts)
  const getSourceColor = (sourceName, index) => {
    // Create a mapping of source names to colors for consistency
    const sourceColorMap = {};

    if (dashboardData.sourceCounts && dashboardData.conversionBySource) {
      // Get all unique source names from both datasets
      const allSources = [
        ...dashboardData.sourceCounts.map((item) => item.sourceName),
        ...dashboardData.conversionBySource.map((item) => item.sourceName),
      ];

      const uniqueSources = [...new Set(allSources)];

      // Assign colors to each unique source
      uniqueSources.forEach((source, idx) => {
        sourceColorMap[source] = sourceColors[idx % sourceColors.length];
      });
    }

    // Return color for the specific source, or fallback to index-based color
    return (
      sourceColorMap[sourceName] || sourceColors[index % sourceColors.length]
    );
  };
  
  // Updated source chart data (Leads by Source) - removed borders
  const sourceChartData = {
    labels:
      dashboardData.sourceCounts?.map(
        (item) => `${item.sourceName} (${item.count})`
      ) || [],
    datasets: [
      {
        data: dashboardData.sourceCounts?.map((item) => item.count) || [],
        backgroundColor:
          dashboardData.sourceCounts?.map((item, index) =>
            getSourceColor(item.sourceName, index)
          ) || [],
        borderColor: "transparent", // Remove black border
        borderWidth: 0, // Remove border
        hoverBorderWidth: 0, // Remove hover border
        hoverOffset: 15,
        spacing: 2,
        borderRadius: 8,
      },
    ],
  };

  // Monthly Trend Chart Data
  const trendChartData = {
    labels: dashboardData.monthlyTrend?.map((item) => item.displayDate) || [],
    datasets: [
      {
        label: "Leads",
        data: dashboardData.monthlyTrend?.map((item) => item.leadCount) || [],
        borderColor: "#4361ee",
        backgroundColor: "rgba(67, 97, 238, 0.1)",
        tension: 0.4,
        fill: true,
        pointBackgroundColor: "#4361ee",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  // Updated conversion chart data (Conversion by Source) - removed borders
  const conversionChartData = {
    labels:
      dashboardData.conversionBySource?.map((item) => item.sourceName) || [],
    datasets: [
      {
        label: "Conversion Rate %",
        data:
          dashboardData.conversionBySource?.map(
            (item) => item.conversionRate
          ) || [],
        backgroundColor:
          dashboardData.conversionBySource?.map((item, index) =>
            getSourceColor(item.sourceName, index)
          ) || [],
        borderColor: "transparent", // Remove black border
        borderWidth: 0, // Remove border
        borderRadius: 8,
        borderSkipped: false,
      },
    ],
  };

  // Source chart options (Leads by Source - Doughnut) - dark text
  const sourceChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          font: {
            size: 12,
            family: "'Inter', sans-serif",
            weight: "500",
          },
          color: "#1F2937", // Dark text color
        },
      },
      tooltip: {
        backgroundColor: "rgba(17, 24, 39, 0.95)",
        titleColor: "#F9FAFB",
        bodyColor: "#D1D5DB",
        borderColor: "#374151",
        borderWidth: 1,
        cornerRadius: 8,
        boxPadding: 10,
        usePointStyle: true,
        callbacks: {
          label: function (context) {
            const label = context.label.replace(/\(\d+\)/, "").trim();
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} leads (${percentage}%)`;
          },
          labelColor: function (context) {
            return {
              backgroundColor:
                context.dataset.backgroundColor[context.dataIndex],
              borderColor: "transparent", // Remove border
              borderWidth: 0,
              borderRadius: 2,
            };
          },
        },
      },
      title: {
        display: true,
        text: "Leads by Source",
        color: "#1F2937", // Dark text color
        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
    cutout: "55%",
    animation: {
      animateScale: true,
      animateRotate: true,
      duration: 1000,
      easing: "easeOutQuart",
    },
    elements: {
      arc: {
        borderWidth: 0, // Remove border
        borderColor: "transparent",
      },
    },
  };

  const trendChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#4361ee",
        borderWidth: 1,
        callbacks: {
          label: function (context) {
            return `Leads: ${context.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
        ticks: {
          stepSize: 1,
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  // Conversion chart options (Conversion by Source - Bar) - dark text
  const conversionChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(17, 24, 39, 0.95)",
        titleColor: "#F9FAFB",
        bodyColor: "#D1D5DB",
        borderColor: "#374151",
        borderWidth: 1,
        cornerRadius: 8,
        callbacks: {
          label: function (context) {
            const sourceData =
              dashboardData.conversionBySource?.[context.dataIndex];
            if (sourceData) {
              return [
                `Source: ${sourceData.sourceName}`,
                `Conversion Rate: ${sourceData.conversionRate}%`,
                `Total Leads: ${sourceData.totalLeads}`,
                `Converted: ${sourceData.convertedLeads}`,
              ];
            }
            return `Conversion Rate: ${context.raw}%`;
          },
          labelColor: function (context) {
            return {
              backgroundColor:
                context.dataset.backgroundColor[context.dataIndex],
              borderColor: "transparent", // Remove border
              borderWidth: 0,
              borderRadius: 2,
            };
          },
        },
      },
      title: {
        display: true,
        text: "Conversion by Source",
        color: "#1F2937", // Dark text color
        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: function (value) {
            return value + "%";
          },
          color: "#1F2937", // Dark text color
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
        title: {
          display: true,
          text: "Conversion Rate %",
          color: "#1F2937", // Dark text color
        },
      },
      x: {
        ticks: {
          color: "#1F2937", // Dark text color
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
        title: {
          display: true,
          text: "Sources",
          color: "#1F2937", // Dark text color
        },
      },
    },
  };

  // Calculate total converted leads
  const totalConvertedLeads =
    dashboardData.conversionBySource?.reduce(
      (total, source) => total + source.convertedLeads,
      0
    ) || 0;

  // SVG Icons
  const PlusCircleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="16"></line>
      <line x1="8" y1="12" x2="16" y2="12"></line>
    </svg>
  );

  const ProcessingIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M21 12a9 9 0 1 1-9-9"></path>
      <path d="M21 3v6h-6"></path>
      <path d="M21 3l-9 9"></path>
    </svg>
  );

  const CheckCircleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  );

  const TimesCircleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
  );

  const SyncIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M23 4v6h-6"></path>
      <path d="M1 20v-6h6"></path>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path>
      <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path>
    </svg>
  );

  const LockIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </svg>
  );

  const BanIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
    </svg>
  );

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
    return null;
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MarketingTabs pageName="LEADDASHBOARD" />
                </div>
                <div className="card-body">
                  {/* Filter Section */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card bg-light">
                        <div className="card-body p-3">
                          <div className="row g-3 align-items-end">
                            {/* Date Range */}
                            <div className="col-md-4">
                              <div className="row g-2">
                                <div className="col-6">
                                  <label className="form-label small">
                                    From Date
                                  </label>
                                  <DatePicker
                                    selected={fromDate}
                                    onChange={handleFromDateChange}
                                    customInput={<CustomDateInput />}
                                    dateFormat="dd-MMM-yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                  />
                                </div>
                                <div className="col-6">
                                  <label className="form-label small">
                                    To Date
                                  </label>
                                  <DatePicker
                                    selected={toDate}
                                    onChange={handleToDateChange}
                                    customInput={<CustomDateInput />}
                                    dateFormat="dd-MMM-yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Source Filter */}
                            <div className="col-md-2">
                              <label
                                htmlFor="sourceFilter"
                                className="form-label fw-semibold"
                              >
                                Source
                              </label>
                              <select
                                className="form-select form-select-sm"
                                id="sourceFilter"
                                value={sourceFilter}
                                onChange={(e) =>
                                  setSourceFilter(e.target.value)
                                }
                                style={{ height: "38px" }}
                              >
                                <option value="all">All Sources</option>
                                <option value="B2C">B2C</option>
                                <option value="WalkIn">Walk In</option>
                                <option value="ChatBot">ChatBot</option>
                                <option value="Phone Call">Phone Call</option>
                                <option value="General">General</option>
                              </select>
                            </div>

                            {/* Status Filter */}
                            <div className="col-md-2">
                              <label
                                htmlFor="statusFilter"
                                className="form-label fw-semibold"
                              >
                                Status
                              </label>
                              <select
                                className="form-select form-select-sm"
                                id="statusFilter"
                                value={statusFilter}
                                onChange={(e) =>
                                  setStatusFilter(e.target.value)
                                }
                                style={{ height: "38px" }}
                              >
                                <option value="all">All Statuses</option>
                                {leadStatuses.map((status) => (
                                  <option
                                    key={status.leadStatusId}
                                    value={status.leadStatusName}
                                  >
                                    {status.leadStatusName}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Buttons */}
                            <div className="col-md-2">
                              <div className="d-flex gap-2 mt-4">
                                <button
                                  className="btn btn-primary btn-sm w-100"
                                  onClick={GetData}
                                  style={{ height: "38px" }}
                                  disabled={isLoading}
                                >
                                  {isLoading ? "Loading..." : "Apply"}
                                </button>
                                <button
                                  className="btn btn-danger btn-sm w-100"
                                  onClick={resetFilters}
                                  style={{ height: "38px" }}
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Stats Overview */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card bg-white">
                        <div className="card-body bg-light">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="card-title mb-0 text-dark">
                              Overview
                            </h5>
                            <div className="d-flex gap-3">
                              <span className="badge bg-primary fs-6">
                                Total Leads: {dashboardData.totalLeads}
                              </span>
                              <span className="badge bg-success fs-6">
                                Converted: {totalConvertedLeads}
                              </span>
                            </div>
                          </div>

                          {/* Date Range Info */}
                          {dashboardData.dateRange?.fromDate && (
                            <div className="row mb-3">
                              <div className="col-12">
                                <small className="text-muted">
                                  Showing data from{" "}
                                  {moment(
                                    dashboardData.dateRange.fromDate
                                  ).format("DD MMM YYYY")}{" "}
                                  to{" "}
                                  {moment(
                                    dashboardData.dateRange.toDate
                                  ).format("DD MMM YYYY")}
                                </small>
                              </div>
                            </div>
                          )}

                          {/* Status Cards - UPDATED with combined NOT RESPONDING/NOT WORKING */}
                          {isLoading ? (
                            <div className="text-center py-4">
                              Loading status data...
                            </div>
                          ) : (
                            <div className="row">
                              {[
                                "NEW",
                                "PROCESSING",
                                "FOLLOW UP",
                                "REPLIED",
                                "NOT RESPONDING/NOT WORKING", // Combined status
                                "CLOSED",
                              ].map((statusName, index) => {
                                // Handle combined status
                                let count = 0;
                                let statusConfig;
                                let icon;
                                
                                if (statusName === "NOT RESPONDING/NOT WORKING") {
                                  // Sum up counts from both NOT RESPONDING and NOT WORKING
                                  const notRespondingData = dashboardData.leadStatusCounts?.find(
                                    (item) => item.leadStatusName === "NOT RESPONDING"
                                  );
                                  const notWorkingData = dashboardData.leadStatusCounts?.find(
                                    (item) => item.leadStatusName === "NOT WORKING"
                                  );
                                  
                                  count = (notRespondingData?.count || 0) + (notWorkingData?.count || 0);
                                  statusConfig = statusColors["NOT RESPONDING"]; // Use NOT RESPONDING color
                                  icon = <TimesCircleIcon />; // Use NOT RESPONDING icon
                                } else {
                                  // Find the status data from dashboard for individual statuses
                                  const statusData = dashboardData.leadStatusCounts?.find(
                                    (item) => item.leadStatusName === statusName
                                  );
                                  count = statusData ? statusData.count : 0;
                                  statusConfig = statusColors[statusName] || statusColors["NEW"];
                                  
                                  switch (statusName) {
                                    case "NEW":
                                      icon = <PlusCircleIcon />;
                                      break;
                                    case "PROCESSING":
                                      icon = <ProcessingIcon />;
                                      break;
                                    case "FOLLOW UP":
                                      icon = <SyncIcon />;
                                      break;
                                    case "CLOSED":
                                      icon = <LockIcon />;
                                      break;
                                    case "REPLIED":
                                      icon = <CheckCircleIcon />;
                                      break;
                                    default:
                                      icon = <PlusCircleIcon />;
                                  }
                                }

                                // For the combined card, use a special display name
                                const displayName = statusName === "NOT RESPONDING/NOT WORKING" 
                                  ? "NOT RESPONDING/NOT WORKING" 
                                  : statusName;

                                return (
                                  <div
                                    key={index}
                                    className="col-md-4 col-lg-2 mb-3"
                                  >
                                    <div
                                      className="card text-white border-0 shadow-sm h-100"
                                      style={{
                                        background: statusConfig.background,
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                        transition:
                                          "transform 0.3s ease, box-shadow 0.3s ease",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform =
                                          "translateY(-8px) scale(1.03)";
                                        e.currentTarget.style.boxShadow =
                                          "0 8px 20px rgba(0,0,0,0.3)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform =
                                          "translateY(0) scale(1)";
                                        e.currentTarget.style.boxShadow =
                                          "0 4px 12px rgba(0,0,0,0.2)";
                                      }}
                                    >
                                      <div className="card-body d-flex justify-content-between align-items-center p-3">
                                        {/* Left Side */}
                                        <div className="text-start">
                                          <p className="mb-1 fw-semibold text-uppercase small text-white">
                                            {displayName}
                                          </p>
                                          <h2
                                            className="mb-0 fw-bold text-white"
                                            style={{ fontSize: "2.5rem" }}
                                          >
                                            {count}
                                          </h2>
                                        </div>

                                        {/* Right Side Icon */}
                                        <div
                                          className="status-icon fs-1"
                                          style={{
                                            opacity: 0.9,
                                            transform: "scale(1)",
                                            transition: "transform 0.4s ease",
                                          }}
                                        >
                                          {icon}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Charts */}
                  <div className="row mb-4">
                    {/* Leads by Source */}
                    <div className="col-md-6 mb-3">
                      <div
                        className="card h-100 bg-white border-0 shadow-sm"
                        style={{
                          borderRadius: "15px",
                          transition:
                            "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(-8px) scale(1.03)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 25px rgba(0,0,0,0.25)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(0) scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                      >
                        <div className="card-body bg-light">
                          <h5 className="card-title text-dark">
                            Leads by Source
                          </h5>
                          <div style={{ height: "300px" }}>
                            {isLoading ? (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                Loading...
                              </div>
                            ) : dashboardData.sourceCounts?.length > 0 ? (
                              <Doughnut
                                data={sourceChartData}
                                options={sourceChartOptions}
                              />
                            ) : (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                No data available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Conversion by Source */}
                    <div className="col-md-6 mb-3">
                      <div
                        className="card h-100 bg-white border-0 shadow-sm"
                        style={{
                          borderRadius: "15px",
                          transition:
                            "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(-8px) scale(1.03)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 25px rgba(0,0,0,0.25)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(0) scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                      >
                        <div className="card-body bg-light">
                          <h5 className="card-title text-dark">
                            Conversion by Source
                          </h5>
                          <div style={{ height: "300px" }}>
                            {isLoading ? (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                Loading...
                              </div>
                            ) : dashboardData.conversionBySource?.length > 0 ? (
                              <Bar
                                data={conversionChartData}
                                options={conversionChartOptions}
                              />
                            ) : (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                No data available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Leads Trend */}
                  <div className="row">
                    <div className="col-12 mb-3">
                      <div
                        className="card h-100 bg-white border-0 shadow-sm"
                        style={{
                          borderRadius: "15px",
                          transition:
                            "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(-8px) scale(1.03)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 25px rgba(0,0,0,0.25)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(0) scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                      >
                        <div className="card-body bg-light">
                          <h5 className="card-title text-dark">
                            Leads Trend (
                            {dashboardData.monthlyTrend?.length || 0} Days)
                          </h5>
                          <div style={{ height: "400px" }}>
                            {isLoading ? (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                Loading...
                              </div>
                            ) : dashboardData.monthlyTrend?.length > 0 ? (
                              <Line
                                data={trendChartData}
                                options={trendChartOptions}
                              />
                            ) : (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                No trend data available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadManagementDashboard;